export default __webpack_public_path__ + "static/media/046-charity.18f666a0.svg";